import { Injectable } from "@angular/core";
import { StateService } from "@core-services/state.service";
import { Observable } from "rxjs";
import { FiatDepositStepsData } from "@modules/+new/payments/features/fiat-deposit/domain/entities/fiat-deposit-steps-data.model";
import { FiatDeposit } from "@modules/+new/payments/features/fiat-deposit/domain/entities/fiat-deposit.model";

const initialState: FiatDeposit = null;

@Injectable({
	providedIn: "any"
})
export class FiatDepositStateService extends StateService<FiatDeposit> {
	public constructor() {
		super(initialState);
	}

	public getStepsData$(): Observable<FiatDepositStepsData> {
		return this.select((state: FiatDeposit) => state?.stepsData);
	}

	public setStepsData(stepsData: FiatDepositStepsData): void {
		const newState = {
			...this.state,
			stepsData
		};
		this.setState(newState);
	}

	public isStepsDataStateLoaded(): boolean {
		return !!this.state?.stepsData;
	}
}
